// Контакты:
export const contacts = {
	email: 'artem@globalcode.eu',
	ITN: '480204747530', // (ИНН)
	PSRN: '321482700034959', // (ОГРН)
	whatsapp: 'https://wa.me/79997887779',
	phone: '+7 (999) 788-77-79',
	vk: 'https://vk.com/globalcode_eu',
	facebook: 'https://www.facebook.com/artemiikok',
	instagram: '',
	youtube: 'https://www.youtube.com/channel/UCpjZNtAusBXVX5X57OcMXpA',
	telegram: 'https://t.me/globalcodeeu',
}

// Мобильные приложения:
export const mobileApps = {
	googleplay: '#',
	appstore: '#',
}
